import { useEffect, useState } from 'react';
import { GoogleMapsService } from 'services/GoogleMapsService';

// Custom hook to handle Google Maps loading
export const useGoogleMapsLoader = () => {
  const [isLoaded, setIsLoaded] = useState(() => {
    // Check if Google Maps is already loaded
    return !!(window as any).google?.maps?.places;
  });
  const [mapsError, setMapsError] = useState<Error | null>(null);

  useEffect(() => {
    // If already loaded, no need to load again
    if (isLoaded) return;

    // Clean up any stale PAC containers from previous sessions
    const existingContainers = document.querySelectorAll('.pac-container');
    existingContainers.forEach(container => container.remove());

    GoogleMapsService.getInstance()
      .load()
      .then(() => setIsLoaded(true))
      .catch(err => {
        console.error('Error loading Google Maps API:', err);
        setMapsError(err);
      });

    // Don't reset the loaded state on unmount since Google Maps API
    // remains loaded globally and should be reusable across components
  }, [isLoaded]);

  return { isLoaded, mapsError };
};
